import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  selectedModelVersion: false,
};

const datasetScoringSlice = createSlice({
  name: "datasetScoring",
  initialState,
  reducers: {
    setSelectedModelVersion(state, action) {
      state.selectedModelVersion = action.payload;
    },
  },
});

export const { setSelectedModelVersion } = datasetScoringSlice.actions;

export default datasetScoringSlice.reducer;
